// External libraries
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { navy } from '@zocdoc/branding/colors';

// Icon code
import { Icon } from './_base';

const ZeeSVG = styled(Icon).attrs({ viewBox: '0 0 32 40' })`
    width: 0.8em;
`;

const ZeeSmileSVG = styled(Icon).attrs({ viewBox: '0 0 30 40' })`
    width: 0.75em;
`;

const Zee = ({ color = navy, expression, ...props }) => {
    switch (expression) {
        case Zee.expression.wink:
            return (
                <ZeeSVG data-test="icon-zee-wink" {...props}>
                    <path
                        d="M24.4,4.2L2.1,35.5c0,0,0,0,0,0c-0.1,0.2-0.2,0.3-0.2,0.5c0,0,0,0,0,0.1v0.1V40h27.4v-4.2H6.8L29.1,4.5c0,0,0,0,0,0c0.1-0.2,0.2-0.3,0.2-0.5c0,0,0,0,0-0.1V3.7V0H1.9v4.2H24.4z"
                        fill={color}
                    />
                    <path
                        d="M3.3,23.2c1.7,0,3.2-1.4,3.2-3.2s-1.4-3.2-3.2-3.2S0.2,18.3,0.2,20S1.6,23.2,3.3,23.2"
                        fill={color}
                    />
                    <rect
                        fill={color}
                        height="2.5"
                        width="6.3"
                        x="25.5"
                        y="18.3"
                    />
                </ZeeSVG>
            );
        case Zee.expression.smile:
            return (
                <ZeeSmileSVG data-test="icon-zee-smile" {...props}>
                    <path d="M3,22a3,3,0,1,0-3-3,3,3,0,0,0,3,3" fill={color} />
                    <path d="M27,22a3,3,0,1,0-3-3,3,3,0,0,0,3,3" fill={color} />
                    <path
                        d="M28.06,32.62A26.93,26.93,0,0,1,6.75,34.71L27.84,3.5A1,1,0,0,0,28,3s0,0,0-.08V0H2V4H22.49L2.16,34.09a1,1,0,0,0-.16.49s0,0,0,.08H2v2.49a31,31,0,0,0,28-1Z"
                        fill={color}
                    />
                </ZeeSmileSVG>
            );
        // no default
    }
};

Zee.expression = {
    wink: 'wink',
    smile: 'smile',
};

Zee.propTypes = {
    expression: PropTypes.oneOf(Object.values(Zee.expression)).isRequired,
};

export { Zee as default, Zee };
